module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAABHNCSVQICAgIfAhkiAAAAN9JREFUOE+d1DFKA0EUxvH/RypBmxCwF2wF4z2CnQfwAGlsRdAziNh4gfRaSpC0HiNtGtNY+MkLUyzL7s7MTjvv/Ri+9xiRObaPgC/gXtJHX7kKoDvgEfgBXiQ9dPVkoWiyvQauEvbahRVBJVgxlMOqoCHsAKXJ/OaCb9x/AvNmZrJ9CzwBpxVQlO6BE2ALPAf0DVxWIu3yTUChLoHjCmwG3KSeP0mTMWFfAJHRFDgg8YAqyHYnUgUNIcVQDimCbMe+rICzZibtwWQzsr0A3oCdpPPR30ja/GvgXVLv9v8DrERdSvFwetoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/rightIcon.png
// module id = 9ga0
// module chunks = 3